"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const leaders = [{
  name: "Levent Hamdemir",
  position: "Partner",
  bio: "Spearheading global expansion strategies with a focus on emerging markets, cross-border M&A, and establishing resilient operational footprints for multinational brands.",
  imgFormal: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582219/img/levent_hamdemir_formal_portrait.png",
  imgAction: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582219/img/levent_hamdemir_action_shot.png"
}, {
  name: "Onur Turan",
  position: "Partner",
  bio: "Architecting robust corporate structures and driving operational excellence across complex, global supply chains to match dynamic market demands with entrepreneurial vision.",
  imgFormal: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582219/img/onur_turan_formal_portrait.png",
  imgAction: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582219/img/onur_turan_action_shot.png"
}, {
  name: "Fatih Teksal",
  position: "Partner",
  bio: "Advising top-tier manufacturers on market penetration, premium brand positioning, and sustainable growth trajectories across diverse international landscapes.",
  imgFormal: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582219/img/fatih_teksal_formal_portrait.png",
  imgAction: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582219/img/fatih_teksal_action_shot.png"
}];
export default function TheLeadershipBench() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-leadership-bench" className="relative bg-background py-24 lg:py-32 overflow-hidden" ref={ref}>
      {}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582219/img/subtle_paper_grain_texture.png)] bg-repeat" aria-hidden="true" />

      <div className={`container mx-auto px-6 relative z-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        {}
        <div className="flex flex-col items-center justify-center mb-20 lg:mb-28">
          <div className="w-px h-16 bg-primary/20 mb-8" aria-hidden="true" />
          <span className="text-xs md:text-sm font-sans tracking-[0.25em] text-muted-foreground uppercase mb-6 text-center">
            The Careful Consulting
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-primary text-center max-w-4xl leading-tight mb-8">
            100 Years of Collective Experience
          </h2>
          <p className="text-sm md:text-base font-sans tracking-wide text-secondary-foreground text-center max-w-2xl leading-relaxed">
            Building businesses, global supply chains, and brands matching the
            demand with the entrepreneurs across all major continents.
          </p>
          <div className="w-px h-16 bg-primary/20 mt-12" aria-hidden="true" />
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16">
          {leaders.map((leader, i) => <div key={leader.name} data-index={i} className="group flex flex-col items-center text-center">
              {}
              <div className="relative w-full aspect-[3/4] overflow-hidden mb-8 bg-muted">
                {}
                <img src={leader.imgFormal} alt={`${leader.name} - Formal Portrait`} className="absolute inset-0 w-full h-full object-cover grayscale contrast-[1.15] transition-all duration-700 ease-in-out group-hover:opacity-0 group-hover:scale-105" />
                {}
                <img src={leader.imgAction} alt={`${leader.name} - In Action`} className="absolute inset-0 w-full h-full object-cover grayscale contrast-[1.15] opacity-0 scale-105 transition-all duration-700 ease-in-out group-hover:opacity-100 group-hover:scale-100" />
                {}
                <div className="absolute inset-0 mix-blend-overlay opacity-20 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582219/img/photographic_film_grain.png)] pointer-events-none" aria-hidden="true" />
              </div>

              {}
              <h3 className="text-2xl lg:text-3xl font-sans font-bold text-primary tracking-tight mb-2">
                {leader.name}
              </h3>
              <p className="text-xs font-sans tracking-[0.2em] text-muted-foreground uppercase mb-6">
                {leader.position}
              </p>
              <p className="font-serif text-secondary-foreground leading-relaxed text-base lg:text-lg px-4 mb-8">
                {leader.bio}
              </p>

              {}
              <div className="mt-auto">
                <Button variant="ghost" className="font-sans tracking-widest uppercase text-xs text-primary hover:bg-transparent hover:text-primary/70 transition-colors group/btn">
                  Read Full Bio
                  <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover/btn:translate-x-1" />
                </Button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}